module.exports = __webpack_public_path__ + "img/testimonial_2.68b3fc5e.png";